
const headers = [
  {
    label: 'วันที่ดำเนินการ / รหัสการร้องขอ / รหัสเรื่องร้องทุกข์',
    field: 'caseCode',
  },
  {
    label: 'หน่วยงาน',
    field: 'department',
  },
  {
    label: 'สถานะ / mode / ผู้ดำเนินการ',
    field: 'status',
  },
  {
    label: 'ข้อมูลตอบกลับ',
    field: 'dataDescription',
    tdClass: 'text-center',
    thClass: 'text-center',
  },
  {
    label: 'ดำเนินการ',
    field: 'action',
    thClass: 'text-center',
    tdClass: 'text-center',
  },
]

export default headers